import { OutOfPageAdType, OutOfPageTypes } from '../types'

export function isOutOfPageAdType(type: string): type is OutOfPageAdType {
    return OutOfPageTypes.includes(type as OutOfPageAdType)
}
